import { computed } from "vue";

import { UserData } from "@/@types/global";
import { RolTypes } from "@/app/shared/utils/enums";

type RoleId = (typeof RolTypes)[keyof typeof RolTypes];

export function useUserNeedPermissions(store: any, neededRoles: RoleId[]) {
  const userData = computed<UserData>(() => store.getters["getDataUser"]);

  return !neededRoles.includes(userData.value?.role?.id as RoleId);
}
